import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  ImmoMapImmoTask,
  ImmoMapItem,
  ImmoMapSubProject,
  isImmoMapImmoTask,
} from './model/immo-map-sub-project';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import DateHelper from 'src/app/helpers/date-helper';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import IPBoardPlacementType from '../../../../../../model/product/ip-board/ip-board-placement-type';
import { Observable } from 'rxjs';
import { _get, _post } from '../../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class ImmoMapControllerRequestService {
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly post: <T>(
    path: string,
    body: ImmoMapFilterObject,
    deserialize: (response: any) => T
  ) => Observable<T>;

  private readonly deserializeImmoMapItems = (
    res: ImmoMapItem[]
  ): ImmoMapItem[] => {
    if (CollectionHelper.isPopulated(res)) {
      res.forEach((item) => {
        if (isImmoMapImmoTask(item)) {
          if (item.tourDate != null) {
            item.tourDate = DateHelper.parseDate(item.tourDate);
          }
        }
      });
    }
    return res;
  };

  private readonly deserializeSingleSubProjectForMapResponse = (res) =>
    res as SingleSubProjectForMapResponse;
  private readonly deserializeSingleImmoTaskForMapResponse = (
    res: SingleImmoTaskForMapResponse
  ) => {
    if (res.immoTask != null && res.immoTask.tourDate != null) {
      res.immoTask.tourDate = DateHelper.parseDate(res.immoTask.tourDate);
    }
    return res;
  };
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post('/tours', requestServices);
    this.get = _get('/tours', requestServices);
  }

  public getImmoItems(
    filterObject: ImmoMapFilterObject
  ): Promise<ImmoMapItem[]> {
    if (
      filterObject.filterTypes != null &&
      filterObject.filterTypes.length > 1 &&
      filterObject.filterTypes.includes(ImmoMapFilterType.ALL)
    ) {
      throw new Error(
        'Filter voor alle opdrachten kan niet gecombineerd worden met andere filters'
      );
    }
    return this.post(
      '/immoItemsMap',
      filterObject,
      this.deserializeImmoMapItems
    ).toPromise();
  }

  public singleSubProjectForMap(
    id: number
  ): Promise<SingleSubProjectForMapResponse> {
    return this.get(
      `/singleSubProjectForMap/${id}`,
      this.deserializeSingleSubProjectForMapResponse
    ).toPromise();
  }

  public singleImmoTaskForMap(
    id: number
  ): Promise<SingleImmoTaskForMapResponse> {
    return this.get(
      `/singleImmoTaskForMap/${id}`,
      this.deserializeSingleImmoTaskForMapResponse
    ).toPromise();
  }
}

export enum ImmoMapFilterType {
  ALL = 'ALL',
  WITH_DATE = 'WITH_DATE',
  BASE_PROJECT = 'BASE_PROJECT',
  ADJUSTMENT = 'ADJUSTMENT',
  SOLD_RENTED = 'SOLD_RENTED',
  REPO = 'REPO',
  NOT_EXECUTED = 'NOT_EXECUTED',
  NO_TOUR = 'NO_TOUR',
  ALREADY_TOUR = 'ALREADY_TOUR',
  TASK = 'TASK',
}

export interface ImmoMapFilterObject {
  companyName?: string;
  placementTypes?: IPBoardPlacementType[];
  filterTypes?: ImmoMapFilterType[];
}

export interface SingleSubProjectForMapResponse {
  subProject: ImmoMapSubProject;
  locked: boolean;
  placerId: number;
  tourDate: Date;
}

export interface SingleImmoTaskForMapResponse {
  immoTask: ImmoMapImmoTask;
  locked: boolean;
  placerId: number;
  tourDate: Date;
}
